import React from "react";
import { useTranslation } from "react-i18next";

import { Props } from "./types";
import styles from "./styles.scss";

function ResourceTimeOverview(props: Props) {
  const { t } = useTranslation();

  return (
    <div className={styles.resourceTimeOverview}>
      <div className={styles.cell}>
        <p className={styles.text}>{t("timeSheet.allocatedTime")}</p>
      </div>
      <div className={styles.cell}>
        <p className={styles.text}>{t("timeSheet.spentTime")}</p>
      </div>
      <div className={styles.cell}>
        <p className={styles.text}>{t("timeSheet.spentTimeInWeek")}</p>
      </div>
      <div className={styles.cell}>
        <p className={styles.text}>{t("timeSheet.remainingTime")}</p>
      </div>
      {props.showCompletionColumn && (
        <div className={styles.cell}>
          <p className={styles.text}>{t("timeSheet.percent")}</p>
        </div>
      )}
    </div>
  );
}

export { ResourceTimeOverview };
